/** @jsxImportSource @emotion/react */
import { ReactNode } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import Typography from "@mui/material/Typography";

import {
  AvailableIcon,
  DeviceWorkIcon,
  DrivingCircleIcon,
  RestIcon,
  UnknownIcon
} from "@dotnet/telematics-design-system";

import { useTableStyles } from "../../styles/styles";
import { lastActivityState } from "../../types";

interface IDriverLastActivityState {
  lastActivity: string;
}

const DriverLastActivityState = ({
  lastActivity
}: IDriverLastActivityState) => {
  const { t } = useTranslation();
  const { driverLastActivityDiv, driverLastActivityIconDiv } = useTableStyles();

  const isEmptyString = lastActivity === "";
  const iconSize = 16;

  const generateLastActivityIcon = () => {
    const lastActivityStateIcons: {
      [key: string]: (props: any) => ReactNode;
    } = {
      [lastActivityState.BreakOrRest]: RestIcon,
      [lastActivityState.Available]: AvailableIcon,
      [lastActivityState.Work]: DeviceWorkIcon,
      [lastActivityState.Drive]: DrivingCircleIcon,
      [lastActivityState.Unknown4]: UnknownIcon,
      [lastActivityState.Unknown5]: UnknownIcon
    };

    const IconComponent = lastActivityStateIcons[lastActivity];

    return IconComponent ? (
      <div
        css={css(driverLastActivityIconDiv)}
        data-testid="last-activity-icon"
      >
        <IconComponent width={iconSize} height={iconSize} />
      </div>
    ) : null;
  };

  return (
    <div css={css(driverLastActivityDiv)}>
      {generateLastActivityIcon()}
      <Typography variant="body2Medium" sx={{ paddingLeft: "4px" }}>
        {isEmptyString ? "-" : t(`Drivers##last activity##${lastActivity}`)}
      </Typography>
    </div>
  );
};

export default DriverLastActivityState;
